import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { convertSearchKeywordsDataToCsv } from "./utils";
import { downloadFile } from "../../../Common/TextFileDownload/utils";
import { LocationKeywordData } from "../types";

import "./styles.scss";

export interface IDownloadCsvButtonsProps {
  data: LocationKeywordData[];
  dateFrom: dayjs.Dayjs;
  dateTo: dayjs.Dayjs;
}

export const DownloadCsvButtons: React.FC<IDownloadCsvButtonsProps> = ({
  data,
  dateFrom,
  dateTo,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.locationKeywordsChart.downloadCsvButtons.${key}`);

  const downloadCsv = (encoding: "utf-8" | "Shift_JIS") => {
    const content = convertSearchKeywordsDataToCsv(data, dateFrom, dateTo);
    const fileName = `location_keywords_${dateFrom.format(
      "YYYY-MM-DD"
    )}_${dateTo.format("YYYY-MM-DD")}`;

    downloadFile({
      filename: fileName,
      content: content.join("\n"),
      encoding,
    });
  };

  return (
    <>
      <button className="btn btn-border" onClick={() => downloadCsv("utf-8")}>
        {t("download_utf8")}
      </button>
      <button
        className="btn btn-border"
        onClick={() => downloadCsv("Shift_JIS")}
      >
        {t("download_shift_jis")}
      </button>
    </>
  );
};
